export default __webpack_public_path__ + "static/media/P8.104dec90.png";